import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import GlobalLoading from "../common/globalLoading";
import Header from "../common/Header";


const MainLayout = () => {
  return (
    <>
      
      <Box minHeight="100vh">
        {/* header */}
        <Header />
        {/* header */}

        {/* main */}
       
          <Outlet />
        </Box>
        {/* main */}
     

      {/* footer */}
      {/* footer */}
    </>
  );
};

export default MainLayout;